import { render, staticRenderFns } from "./VistaProformaSolicitud.vue?vue&type=template&id=491ad23c"
import script from "./VistaProformaSolicitud.vue?vue&type=script&lang=js"
export * from "./VistaProformaSolicitud.vue?vue&type=script&lang=js"
import style0 from "./VistaProformaSolicitud.vue?vue&type=style&index=0&id=491ad23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports